import ApiService from "@/common/api.service";

const ApiConnections = {

    list(params){
        return ApiService.post("ajax/pcap/connections" , params)
    }
}

export default ApiConnections